interface ProductCardProps {
  id: number;
  title: string;
  image: string | null;
  subtitle?: string; // nama kategori/brand, ditampilkan di bawah title
  onClick?: (id: number) => void;
}

export default function ProductCard({
  id,
  title,
  image,
  subtitle,
  onClick,
}: ProductCardProps) {
  return (
    <div
      onClick={() => onClick?.(id)}
      className="
        group
        relative

        w-full

        aspect-[280/380]

        overflow-hidden

        rounded-[16px]

        bg-gray-200

        cursor-pointer

        transition-transform
        duration-300

        hover:-translate-y-1
        hover:shadow-xl
      ">
      {/* IMAGE */}
      {image ? (
        <img
          src={image}
          alt={title}
          className="
            absolute
            inset-0

            w-full
            h-full

            object-cover

            transition-transform
            duration-500

            group-hover:scale-105
          "
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 text-sm text-gray-400">
          No Image
        </div>
      )}

      {/* GRADIENT OVERLAY + TEXT */}
      <div
        className="
          absolute
          bottom-0
          left-0
          right-0

          bg-gradient-to-t
          from-[#2C4858]
          to-[#3DA4A8]/0

          px-4
          py-4
        ">
        <h3 className="text-white text-[15px] font-semibold leading-tight">
          {title}
        </h3>
        {subtitle && (
          <p className="mt-1 text-white/85 text-[13px]">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
